import adminAxios from '@/shared/api/adminAxiosInstance.js'

export const getCodes = (p) => {
    return adminAxios.get('/admin/promo-codes', {
        params: p
    })
}

export const updateActive = (id) => {
    return adminAxios.put(`/admin/promo-codes/${id}/active`, {})
}

export const deletePromo = (id) => {
    return adminAxios.delete(`/admin/promo-codes/${id}`)
}

export const createPromo = (name, code, discountPercent, promoType, userId = null) => {
    return adminAxios.post('/admin/promo-codes', {
        name,
        code,
        discountPercent,
        promoType,
        userId,
    })
}

export const updatePromo = (id, name, code, discountPercent, promoType, userId = null) => {
    return adminAxios.put(`/admin/promo-codes/${id}`, {
        name,
        code,
        discountPercent,
        promoType,
        userId,
    })
}

export const getPromo = (id) => {
    return adminAxios.get(`/admin/promo-codes/${id}`)
}